import RoutesMap from '../../route_control/RouteControl'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { SessionManager, getConfig } from '../../utils'
import { Loader, ButtonLoader } from '../../components/loader'
import { paymentList, applyCoupon, createInstituteOrder, verifyInstituteOrder, getPaymentOrderStatus } from '../../redux/slices/payment'
import { sidebar } from '../../redux/slices/assets'
import { CreditCard, ShieldCheck, UserRound, Building2, Mail, Phone, IndianRupee, RefreshCw, CircleCheck, CircleX, Clock, CircleAlert } from 'lucide-react'
import { Button, Card } from 'react-bootstrap'
import logo from '../../assets/images/rexolms.png'

export const PaymentImport = {
    RoutesMap,
    useNavigate,
    useSearchParams,
    useDispatch,
    useSelector,
    toast,
    SessionManager,
    getConfig,
    Loader,
    ButtonLoader,
    paymentList,
    applyCoupon,
    createInstituteOrder,
    verifyInstituteOrder,
    getPaymentOrderStatus,
    sidebar,
    CreditCard,
    ShieldCheck,
    UserRound,
    Building2,
    Mail,
    Phone,
    IndianRupee,
    RefreshCw,
    CircleCheck,
    CircleX,
    Clock,
    CircleAlert,
    Button,
    Card,
    logo,
}
